import React from 'react'
import { arrayOf, string, func } from 'prop-types'
import tabDataProp from 'utils/prop_types/TabData'

import Container from 'components/atoms/Container'
import TabItem from 'components/atoms/TabItem'

const TabsNavigator = ({ tabs, activeId, onTabSelect }) => (
  <div className="tabs-navigator">
    <Container fluid>
      <div className="tabs-navigator__container">
        {
          tabs.map((tab, idx) => (
            <TabItem
              title={tab.title}
              active={tab.id === activeId}
              onClick={() => onTabSelect(tab.id)}
              key={`tab-nav-${tab.id}-${idx}`}
            />
          ))
        }
      </div>
    </Container>
    <style jsx>
      {`
        .tabs-navigator {
          background-color: #e3ecf5;
          border-top-left-radius: 8px;
          border-top-right-radius: 8px;
          &__container {
            display: flex;
            align-items: center;
            flex-wrap: no-wrap;
            overflow: scroll;
            @media screen and (min-width: 768px) {
              overflow: unset;
            }
          }
        }
      `}
    </style>
  </div>
)

TabsNavigator.propTypes = {
  tabs: arrayOf(tabDataProp),
  activeId: string,
  onTabSelect: func,
}

export default TabsNavigator
